/**
 * Where to send someone who needs to sign in (again).
 *
 * Patients use the mobile sign-up / sign-in — the app's front door (/, also
 * /start). Most have no email or password at all, so the email login would
 * strand them. Staff and every other role keep the email login (/login). The
 * old long registration (/register) is kept but not linked from anywhere.
 */

import type { UserRole } from '@cardioq/engine-types';

export const PATIENT_SIGN_IN = '/';
export const STAFF_SIGN_IN = '/login';

export function signInPathFor(role: UserRole | null | undefined): string {
  return role === 'PATIENT' ? PATIENT_SIGN_IN : STAFF_SIGN_IN;
}
